/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'
import FirebaseDBService from './FirebaseDBService'
import * as firebase from "firebase"

export default {
	sendGlobalNotification(notification, cb){
		FirebaseDBService.getConstants((err, constants) => {
			if(err){
				cb(err);
				return;
			}
			
			var body = {
				"to": "/topics/global",
				"notification": {
					"title": firebase.apps[0].options.appName,
					"body": notification.title
				},
				"data": {
					"title": firebase.apps[0].options.appName,
					"body": notification.title
				},
				"priority" : "high",
				"time_to_live": 60 * 60 * 24
			};

			var options = {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'key=' + constants.fcm
				}
			};

			Vue.http.post('https://fcm.googleapis.com/fcm/send', body, options).then(response => {
				console.log("Successfully sent notification");
				console.log(response);
				cb(undefined);
			}, errorResponse => {
				console.log("Notification failed");
				console.log(errorResponse);
				cb(errorResponse);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/services/FCMService.js